import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import moment from 'moment-timezone';
import Divider from 'material-ui/Divider';
import QRCode from '../QRCode';

class PrintLabel extends Component {
  static propTypes = {
    trackingNumber: PropTypes.any.isRequired,
    from: PropTypes.any.isRequired,
    to: PropTypes.any.isRequired,
    serviceLevel: PropTypes.any.isRequired,
    code: PropTypes.any.isRequired,
    reference: PropTypes.string.isRequired,
    tracking: PropTypes.number,
    piece: PropTypes.number,
    total: PropTypes.number,
    locations: PropTypes.array.isRequired,
    trackingNumbers: PropTypes.array.isRequired,
    receipt: PropTypes.bool.isRequired,
  };

  getAddressDisplay = (address) => {
    const a = address.split(',');
    return <div><div>{a[0]}</div><div>{a[1]}, {a[2]}, {a[3]}</div></div>;
  }

  render() {
    const { trackingNumber, from, to, serviceLevel:servLevel, reference, piece, total, locations, tabOnTop, trackingNumbers, receipt } = this.props;
    const toAddress = _.find(locations, { id: to.id });
    const fromAddress = _.find(locations, { id: from.id });
    const serviceLevel = servLevel.name;

    const order = { trackingNumber };

    return (
      <div className="printable page-break">
        {tabOnTop && receipt &&
        <div className="header" style={{fontSize: 8, margin: 0, padding: 0, height: 34, width: 200}}>
          <div><span style={{ paddingRight: 8 }}>TRACKING: <strong>[{trackingNumbers.map(item => item.trackingNumber).join(', ')}]</strong></span></div>
          <div><span>REF/PO:<strong>{reference}</strong></span><span>SHIP DATE:<strong>{moment().tz('America/Chicago').format('M/D/YYYY')}</strong></span></div>
        </div>
        }
        <div className="align-center">
          <QRCode text={JSON.stringify(order)} />
        </div>
        <div className="align-center">
          {trackingNumber}
        </div>
        <Divider />
        <div className="from-location-label">
          {from.name}
        </div>
        <div className="from-location-address">
          {this.getAddressDisplay(fromAddress.address.address)}
        </div>
        <Divider />
        <div className="to-location-label">
          {to.name}
        </div>
        <div className="to-location-address">
          {this.getAddressDisplay(toAddress.address.address)}
        </div>
        <Divider />
        <div>
          <p>Reference: {reference}</p>
        </div>
        <Divider />
        <div className="service-level">
          {serviceLevel}
        </div>
        <div>
          Piece: {piece}/{total}
        </div>
        {!tabOnTop && receipt &&
        <div className="footer" style={{ fontSize: 8 }}>
          <div><span>TRACKING: <strong>[{trackingNumbers.map(item => item.trackingNumber).join(', ')}]</strong></span></div>
          <div><span style={{ paddingRight: 9 }}>REF/PO:<strong>{reference}</strong></span><span>SHIP DATE:<strong>{moment().tz('America/Chicago').format('M/D/YYYY')}</strong></span></div>
        </div>
        }
        <div className="hideOnPrint page-break" style={{ marginBottom: (tabOnTop) ? 40 : 4 }}><Divider /></div>
      </div>
    )
  }
}

export default PrintLabel;


// WEBPACK FOOTER //
// ./src/components/PrintLabel/index.js